import React from 'react';

function NotificationBanner({ notifications, onDismiss }) {
    if (notifications.length === 0) return null;

    return (
        <div className="fixed-top mt-2 d-flex flex-column align-items-center" style={{ zIndex: 2000, pointerEvents: 'none' }}>
            {notifications.map(notif => (
                <div 
                    key={notif.id} 
                    className={`alert alert-${notif.type} alert-dismissible fade show shadow-sm mb-2`} 
                    style={{ minWidth: '300px', maxWidth: '500px', pointerEvents: 'auto' }}
                    role="alert"
                >
                    {notif.message}
                    <button type="button" className="btn-close" onClick={() => onDismiss(notif.id)} aria-label="Close"></button>
                </div>
            ))}
        </div>
    );
}

export default NotificationBanner;
